import React, { createContext, useContext, useState } from 'react';

const TABS = ['mosaic', 'spark', 'meet', 'reels', 'dates', 'chat'];
const emptyStacks = () => Object.fromEntries(TABS.map(t => [t, []]));

const NavContext = createContext(null);

export function NavProvider({ children }) {
  const [activeTab, setActiveTabState] = useState('mosaic');
  const [stacks, setStacks]            = useState(emptyStacks);

  const setActiveTab = (tab) => setActiveTabState(tab);

  const push = (screen, props = {}) => {
    setStacks(prev => ({
      ...prev,
      [activeTab]: [...prev[activeTab], { screen, props }],
    }));
  };

  const pop = () => {
    setStacks(prev => {
      const cur = prev[activeTab];
      if (!cur.length) return prev;
      return { ...prev, [activeTab]: cur.slice(0, -1) };
    });
  };

  const currentStack  = stacks[activeTab];
  const currentPushed = currentStack.length > 0 ? currentStack[currentStack.length - 1] : null;

  return (
    <NavContext.Provider value={{ activeTab, setActiveTab, push, pop, currentPushed }}>
      {children}
    </NavContext.Provider>
  );
}

export const useNav = () => {
  const ctx = useContext(NavContext);
  if (!ctx) throw new Error('useNav must be used inside NavProvider');
  return ctx;
};
